import { render, staticRenderFns } from "./ServiceDetailsDialog.vue?vue&type=template&id=8b3aa8a0&scoped=true"
import script from "./ServiceDetailsDialog.vue?vue&type=script&lang=js"
export * from "./ServiceDetailsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3aa8a0",
  null
  
)

export default component.exports